import React, { Component } from 'react';
import './SectionAnnual.css';

import { ReactComponent as CopyIcon } from '../../icons/copy.svg';

class SectionAnnual extends Component {
  constructor(props) {
    super(props);
    this.state = {
      copyMessage: '',
      expandedCategories: {} // Tracks which categories are currently open
    };
  }

  // Formatting Helper
  formatValue = (val, category) => {
    const num = parseFloat(val);
    if (isNaN(num)) return val;

    // Remove decimals if >= 100, otherwise show 2 decimal places
    const decimals = Math.abs(num) >= 100 ? 0 : 2;
    
    // Format with commas and correct decimal precision
    const formattedNum = num.toLocaleString('en-US', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    });

    // Prepend $ for financial metrics
    return category === 'fin' ? `$${formattedNum}` : formattedNum;
  };

  // Pre-process data: Filter out omitted items, group by category, and convert units
  getValidData = () => {
    const { dataAnnual } = this.props;
    if (!dataAnnual) return [];
    
    return dataAnnual
      // Filter out items where omit is explicitly "1" or "1.00"
      .filter(item => item.omit !== "1" && item.omit !== "1.00")
      .map(item => {
        let val = parseFloat(item.val);
        let unit = item.unit;

        // Convert kWh to MWh if value is greater than 1,000,000
        if (item.cat === 'energy' && unit === 'kWh' && val > 1000000) {
          val = val / 1000;
          unit = 'MWh';
        }

        return { ...item, val, unit };
      });
  };

  // Toggle specific category's expanded state
  toggleCategory = (categoryKey) => {
    this.setState(prevState => ({
      expandedCategories: {
        ...prevState.expandedCategories,
        [categoryKey]: !prevState.expandedCategories[categoryKey]
      }
    }));
  };

  copyToClipboard = () => {
    const { metaAnnual } = this.props;
    const validData = this.getValidData();
    let clipboardText = '';

    metaAnnual.forEach(catObj => {
      const categoryData = validData.filter(d => d.cat === catObj.cat);
      
      if (categoryData.length > 0) {
        // Add category title as a section header
        clipboardText += `${catObj.label}\n`;
        clipboardText += `Metric\tValue\n`; // Column headers
        
        // Add data rows
        categoryData.forEach(item => {
          const displayVal = this.formatValue(item.val, item.cat);
          const unitStr = item.cat === 'fin' ? '' : ` ${item.unit}`;
          clipboardText += `${item.label}\t${displayVal}${unitStr}\n`;
        });
        
        clipboardText += '\n'; // Spacer between categories
      }
    });

    navigator.clipboard.writeText(clipboardText.trim()).then(() => {
      this.setState({ copyMessage: 'All data copied to clipboard' });
      setTimeout(() => this.setState({ copyMessage: '' }), 3000);
    }).catch(err => {
      console.error('Failed to copy text: ', err);
      this.setState({ copyMessage: 'Failed to copy data.' });
    });
  };

  render() {
    const { dataAnnual, metaAnnual } = this.props;
    const { copyMessage, expandedCategories } = this.state;

    // Safety check for missing or malformed data
    const hasError = !dataAnnual || !Array.isArray(dataAnnual) || dataAnnual.length === 0 || !metaAnnual;

    if (hasError) {
      return (
        <div className="annual-section">
          <div className="annual-subsection">
            <div className="annual-error-banner">
              <strong>Warning:</strong> Annual metrics could not be processed. Data is missing or unavailable.
            </div>
          </div>
        </div>
      );
    }

    const validData = this.getValidData();

    return (
      <div>
        
        <div className="annual-subsection">
          <div className="annual-header-row">
            <span className="annual-copy-message">{copyMessage}</span>
            <button 
              className="annual-copy-btn" 
              onClick={this.copyToClipboard}
              title="Copy All to Clipboard"
              aria-label="Copy All to Clipboard"
            >
              <CopyIcon className="copy-icon-svg" />
            </button>
          </div>

          {metaAnnual.map(catObj => {
            const categoryData = validData.filter(d => d.cat === catObj.cat);
            
            // Skip rendering if there are no valid metrics for this category
            if (categoryData.length === 0) return null;

            const isExpanded = !!expandedCategories[catObj.cat];

            return (
              <div key={catObj.cat} className="annual-category-container">
                
                {/* Clickable Header */}
                <div 
                  className="annual-category-header" 
                  onClick={() => this.toggleCategory(catObj.cat)}
                >
                  <span className="annual-category-icon">
                    {isExpanded ? '▼' : '▶'}
                  </span>
                  <h3 className="annual-category-title">{catObj.label}</h3>
                </div>

                {/* Conditionally Rendered Table */}
                {isExpanded && (
                  <div className="annual-table-wrapper">
                    <table className="annual-table">
                      <tbody>
                        {categoryData.map((item, index) => (
                          <tr key={`${item.name}-${index}`}>
                            <th>{item.label}</th>
                            <td>
                              {this.formatValue(item.val, item.cat)}
                              {item.cat !== 'fin' && ` ${item.unit}`}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
                
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default SectionAnnual;